'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.restrictedRoute = restrictedRoute;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _componentUtils = require('./componentUtils');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_FORBIDDEN_PAGE = function DEFAULT_FORBIDDEN_PAGE() {
    return _react2.default.createElement(
        'div',
        null,
        'Access denied'
    );
};

function restrictedRoute() {
    var forbiddenPage = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_FORBIDDEN_PAGE;

    return function (requiredRoles) {
        return (0, _componentUtils.restrictedView)(requiredRoles, forbiddenPage);
    };
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/application-bootstrapper/dist/routeUtils.js
// module id = 1329
// module chunks = 118